import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import { url } from "aldoo-ra/CMS/url"
import Typography from "aldoo-ra/Typography"

const AffiliateSection1 = () => {
  return (
    <CMSRender
      contentType="PageSection"
      match={{ "content.name": "Affiliate_Section1" }}
      renderItem={(data,id) => (
        <div className="w-full xl:pt-[55px] px-4 md:px-[56px] xl:px-[76px] mb-[56px] md:mb-[90px] lg:mb-[105px]">
          <div
            key={id} 
            className="w-full max-w-[500px] md:max-w-w1_xl lg:max-w-[900px] xl:max-w-w2_xl 2xl:max-w-w1_xl text-left md:text-center mx-auto"
          >
            <Typography 
              component="h2"
              variant="h1" 
              className="text-left md:text-center mb-[75px] lg:mb-[104px] mx-auto"
            >
              {data.title}
            </Typography>

            <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-between gap-[70px] md:gap-[100px] lg:gap-10 mx-auto">
              {data?.menu?.[0]?.items?.map((item, index) => (
                <div
                  key={index}
                  className="w-full max-w-[500px] lg:w-1/3 lg:max-w-[432px] flex flex-col items-start"
                >
                  <img
                    src={url(item.image)}
                    alt={item.label || item.name || ""}
                    className="w-auto h-[114px] md:h-[140px] lg:h-[148px] 2xl:h-[160px] mb-[38px] object-contain"
                  />

                  {/* Encasing typography in a fixed-height box to ensure equal element positioning in case of two-row text */}
                  <div className="lg:h-20 xl:mb-4">
                    <Typography 
                      component="h3"
                      variant="subtitle_32_heavy" 
                      className="text-text text-left mb-4 lg:mb-8"
                    >
                      {item.label}
                    </Typography>
                  </div>

                  <Typography 
                    variant="body_24"
                    className="text-left text-text my-0"
                  >
                    {item.description}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    />
  )
}

export default AffiliateSection1

export const AldooComponent = {
  id: 'AffiliateSection1',
  component: AffiliateSection1,
  meta: {
    name: 'Affiliate Section 1',
    description: 'First section of the affiliates page with three-column layout',
    category: 'Marketing',
  },
}
